<template >
  <div class="garyaBg montserrat overflow-hidden">
      <section class="text-white flex flex-row justify-center  items-center md:max-w-full max-h-full h-full background-156">
  <div class="container md:mx-auto  md:py-44 lg:py-24">
    <div class=" flexmobile2 flex-row flex lg:flex-row items-center ">
      <div class="lg:w-full  w-full md:relative md:bottom-60 mb-8 lg:mb-0">
        <h1 class="text-3xl sm:text-md md:text-5xl  font-bold mb-6">
          Subscription Management
        </h1>
        <h2 class="text-2xl md:text-4xl  font-medium">
          User Research Study
        </h2>
      </div>
      <div class=" flexmobile2 relative md:right-40 md:top-28 animate__animated animate__zoomInRight">
        <img
        loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/901c899fe294d24805c3a7318806b14f4c871df70e0418cde4311160d1d216af?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b"
          alt="Eater Chicago website mockup"
          class="md:w-full  justify-self-end md:max-w-6xl md:mx-auto"
        />
      </div>
    </div>
  </div>
</section>
<!-- end of first hero section -->

<div class="flex  mx-auto  flexmobile2 flex-col pt-2.5">
  <main class="flex flexmobile2 flex-col items-start px-4 md:px-20 mt-10 md:mt-36 w-full">
    <!-- section two -->
    <section class="w-full md:mt-10">
      <div class="flex flex-col md:flex-row justify-between">
        <div class="w-full md:w-6/12">
          <div class="flex flex-wrap gap-1.5 ">
            <div class="flex flex-col grow shrink-0 my-auto w-full">
               <h1 class="self-start text-4xl font-semibold text-white">My Role</h1>
              <p class="pt-6 text-lg md:pt-16 text-white">
                Performed <span class="text-purple-300">Competitive Analysis</span>
                to understand product gaps <br /><br />
                Conducted <span class="text-purple-300">Observation Studies</span>
                to study user behavior and patterns<br /><br />
                Curated <span class="text-purple-300">Affinity Diagrams, Participant
                Spectrums, Personas & Journey Maps</span> to better analyze the
                data<br /><br />
                Suggested <span class="text-purple-300">Design Recommendations</span>
                for technology-based Subscription Management Solutions
              </p>
            </div>
          </div>
        </div>
        <div class="mobile-hidden">
          <img loading="lazy" class="" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726677459/Line_1_1_soy8jv.png" alt="">
        </div>
        <aside class="flex flex-col ml-0 md:ml-5 w-full md:w-3/12 mt-10 md:mt-0">
          <div class="flex flex-col items-start text-3xl md:text-4xl  text-white">
            <h1 class="self-start text-4xl font-semibold text-white">Duration</h1>
            <p class="pt-6 text-lg text-white">8 weeks</p>
            <h1 class="self-start text-4xl font-semibold text-white pt-6 md:pt-16">Group of 3</h1>
            <h1 class="self-start text-4xl font-semibold text-white pt-6 md:pt-16">Tools</h1>
            <p class="pt-6 text-lg  text-white">
              Zoom, Google Sheets, Miro, Atlas.ti
            </p>
          </div>
        </aside>
      </div>
    </section>
    <!-- end of section two -->

    <section class="mt-44">
      <h1 class="self-start text-4xl font-semibold text-white">Why Study Subscription Management?</h1>
      <ul class=" text-white pt-6 text-lg md:pb-6">
          <li class="pt-6 text-lg ">Subscriptions have become an integral part of daily life, from streaming services to meal kits and so much more.</li>
          <li class="pt-6 text-lg ">However, managing multiple subscriptions can be challenging, especially when it comes to keeping track of varying costs and staying within budget. Financial planning and budgeting, though common across income levels, can be easily derailed by numerous small charges, leading to potential financial stress.</li>
          <li class="pt-6 text-lg ">Therefore, it is essential to maintain control and make informed decisions about subscriptions and spending habits.</li>
          </ul>
    </section>
    <!-- end of section three -->
  </main>
</div>
<!-- Add responsiveness to other sections similarly -->
        <div>
        <main>
        <!-- section four -->
        <section class="md:mt-72 flexmobile2 px-10 background-156 md:h-[440px]  max-md:mt-10 ">
          <div class="p-10  mx-auto">
            <h1 class="self-start text-4xl font-semibold text-white mt-16">Goal</h1>
          <p class="text-white pt-12 text-lg md:pb-6 max-md:max-w-full">
            A technology-based solution to make subscription management easier, faster, and smarter.
          </p>
          </div>
        </section>
        <!-- end of four -->
        </main>
        </div>
        <main class=" mx-auto flexmobile2">
        <!-- five section  -->
        <section class="mt-52 md:px-10   max-md:mt-10 max-md:max-w-full ml-12">
       <h1 class="self-start text-4xl font-semibold text-white">Competitors in the Market</h1>

  <!-- Section 1 -->
  <div class="mt-32 ml-12 md:w-full md:max-w-[1338px] max-md:mt-10 max-md:max-w-full max-md:ml-0">
    <div class="flex md:flex-row max-md:flex-col gap-5">
      <!-- Image -->
      <div class="w-6/12 max-md:w-full">
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/f13e618b8a29ee1ef479d735f6c917c4c3604dcce5b8a747ee2cd4119dd9eb26?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b"
          alt="Mint by Intuit interface"
          class="object-contain w-full aspect-[1.02] max-md:mt-10"
        />
      </div>
      <!-- Description -->
      <div class="md:ml-5 w-6/12 max-md:w-full mt-16">
        <div class="text-white max-md:mt-10 mt-12">
          <h3 class="text-2xl md:text-3xl font-semibold pt-6 dancing-script text-purple-300">Mint by Intuit</h3>
          <p class="pt-6 text-lg md:pb-6">
            A holistic financial solution that combines data from various accounts, credit cards, loans, and investments into one centralized dashboard.
            <br /><br />
            Users can track expenses, budgets, bills, and credit scores.
            <br /><br />
            The app provides reminders and notifications to help avoid late fees.
            <br /><br />
            Helps identify trends and gives financial suggestions to help users.
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Section 2 -->
  <div class="self-center mt-48 ml-14 md:max-w-full w-[1135px] max-md:ml-0 max-md:mt-10 max-md:max-w-full">
    <div class="flex md:flex-row max-md:flex-col gap-5">
      <!-- Description -->
      <div class="w-[66%] max-md:w-full mt-52">
        <div class="text-white max-md:mt-16">
          <h3 class="text-2xl md:text-3xl font-semibold pt-6 dancing-script text-purple-300">Rocket Money</h3>
          <p class="pt-6 text-lg md:pb-6">
            Users can create budgets with customized categories.
            <br /><br />
            The app helps find, manage, and cancel subscriptions.
            <br /><br />
            Through the app, users can pay directly and set up auto payments.
            <br /><br />
            Helps to set and track progress toward goals and monitor their financial habits and behaviors through personalized insights and analysis.
          </p>
        </div>
      </div>
      <!-- Image -->
      <div class="md:w-[34%] flex justify-center mt-16  max-md:w-full">
        <img
          loading="lazy"
          src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1727018730/Subject_56_dwt8ro.png"
          alt="Rocket Money interface"
          class="object-contain md:h-full h-96 md:w-full md:aspect-[0.60] "
        />
      </div>
    </div>
  </div>
</section>

        <!-- section sex -->
        <section class="mt-64 px-20 ml-5 max-md:ml-0 max-md:px-5 max-md:mt-10 max-md:max-w-full">
  <h1 class="self-start text-4xl font-semibold text-white">Findings from Literature Review</h1>

  <!-- List of findings -->
  <ol class="list-decimal mt-16 max-md:mt-10">
    <li class="text-white pt-6 text-lg ">
      Credit card use for subscriptions may lead to overspending and debt accumulation, which can keep people financially strapped. (Xiao, J.O’Neill, 2018)
    </li>
    <p class="pt-6 text-lg dancing-script text-purple-300">Xiao, J. J., & O’Neill, B. (2018). Mental accounting and behavioural hierarchy: Understanding consumer budgeting behaviour. International Journal of Consumer Studies, 42(4), 448–459. https://doi.org/10.1111/ijcs.12445</p>
    <li class="text-white pt-12 text-lg ">
      Financial resources and education make people more likely to budget. (Georgieva, Nitani, & Riding, 2021)
    </li>
    <p class="pt-6 text-lg dancing-script text-purple-300">Georgieva, V., Nitani, M., & Riding, A. (2021). Budgeting and gender: Employees and self‐employed. Family and Consumer Sciences Research Journal, 49(4), 310–327. https://doi.org/10.1111/fcsr.12398</p>
    <li class="text-white pt-12 text-lg ">
      Consumers with lower spending self-control tend to pay higher credit card premiums and save less for the future. (Bearden & Haws, 2012)
    </li>
    <p class="pt-6 text-lg dancing-script text-purple-300">Bearden, W. O., & Haws, K. L. (2012). How low spending control harms consumers. Journal of the Academy of Marketing Science, 40(1), 181–193. https://doi.org/10.1007/s11747-011-0282-1</p>
    <li class="text-white pt-12 text-lg ">
      The subscription market is becoming competitive, and it is hard to acquire new subscribers. (Paris, 2021)
    </li>
    <p class="pt-6 text-lg dancing-script text-purple-300">Paris, M. (2021). People are canceling video streaming subscriptions at record rates ahead of Netflix earnings. Fortune.Com, N.PAG-N.PAG. https://ezproxy.depaul.edu/login?url=https://search.ebscohost.com/login.aspx?direct=true&db=bth&AN=149907447&site=ehost-live&scope=site</p>
    <li class="text-white pt-12 text-lg ">
      People expect dark design patterns as they find it a dependency tactic that companies use to keep people paying. (Maier & Harr, 2020)
    </li>
    <p class="pt-6 text-lg dancing-script text-purple-300">Maier, M., & Harr, R. (2020). Dark design patterns: An end-user perspective. Human Technology, 16(2), 170–199. https://ht.csr-pub.eu/index.php/ht/article/view/6</p>
  </ol>

  <!-- Image with ref -->
  
</section>

<section class=" flex justify-center items-center">
  <img
    ref="animatedImage"
    loading="lazy"
    src="https://cdn.builder.io/api/v1/image/assets/TEMP/b873990a48099c1b0dc6495fa1c3507469a05ee5a05b6c7460710055ccc97d16?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b"
    alt="Subscription management process illustration"
    class="object-contain self-center mb-44 mt-16 max-md:mt-10 max-w-full aspect-[1.52] w-[705px] max-md:w-full"
  />
</section>
        </main>
        <!-- section seven -->
         <SecoundSubSection/>
         <SubscreptionFotterSec/>
</div>
      </template>



<script>
import SecoundSubSection from './SubscriptinPtwo.vue';
import SubscreptionFotterSec from './SubscribtionFotterSec.vue';

export default {
  name: 'SubscriptionManagement',
  components: {
    SecoundSubSection,
    SubscreptionFotterSec,
  },
  mounted() {
    // Set up IntersectionObserver
    const options = {
      threshold: 0.1, // Trigger when at least 10% of the element is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add animation class when the element is in view
          entry.target.classList.add('animate__animated', 'animate__zoomInRight');
          observer.unobserve(entry.target); // Optional: Stop observing after animation is triggered
        }
      });
    }, options);

    // Observe the image element
    const image = this.$refs.animatedImage;
    if (image) {
      observer.observe(image);
    }
  }
};
</script>


<style>
.background-156{
  background: linear-gradient(180deg, #61039B 0%, rgba(66, 7, 102, 0.60) 35.78%, rgba(56, 9, 85, 0.70) 47.7%, rgba(36, 11, 49, 0.80) 71.56%, rgba(25, 13, 32, 0.90) 83.48%, #0F0E0E 95.41%); 
 }
 .background-157{
  background: linear-gradient(360deg, #61039B 0%, rgba(66, 7, 102, 0.60) 35.78%, rgba(56, 9, 85, 0.70) 47.7%, rgba(36, 11, 49, 0.80) 71.56%, rgba(25, 13, 32, 0.90) 83.48%, #0F0E0E 95.41%); 
 }
 @media (max-width:640px) {
  .background-156{
  background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1726677409/Rectangle_4156_1_mb0mxh.png"); 
  background-size: cover;
  background-repeat: no-repeat;
 }
 }

 .garyaBg{
  background-color: #0F0E0E;
  background-image: none;
  }
</style>